/* Filtrous feedback-tab manners - v1.2, 2026-08-26 (Adelaide: "the hotjar is
   blocking the refresh button and i should be able to move it whenever").
   Hotjar's survey tab renders as ordinary DOM in this document (no iframe,
   no shadow root) at z-index 2147483647 - the maximum - so it sits above
   the cart drawer and can cover the "Complete your order" refresh control.
   Two fixes, both non-destructive: Hotjar's own markup is never rewritten,
   only positioned.
   1) STACKING: while the cart drawer (#fcart-veil.on) or the quick-view
      modal (#fqv-veil.on) is open, the tab drops to z-index 2147482000 -
      below those two, still above the rest of the site - and goes back to
      Hotjar's own stacking the moment they close. Because the drawer's veil
      is transparent and pointer-events:none, the tab stays clickable
      everywhere the drawer isn't actually covering.
   2) DRAGGABLE: press and drag the tab to put it anywhere on screen; the
      spot is remembered per browser (localStorage fv3-hj-pos) and re-clamped
      into view on resize. A drag of more than 5px swallows the click that
      ends it, so moving the tab never opens the survey - a plain click still
      does. Reduced-motion safe: no animation is added, and Hotjar's own
      transition is suspended only for the duration of a drag.
   GEOMETRY, and why it looks roundabout (v1.1/v1.2 both fixed bugs here):
   - The visible thing is the union of the widget box AND its tab, which is
     rotated and hangs outside that box; clamping anything else pushes the
     tab off-screen. So all positions refer to the union's top-left.
   - The widget carries its own transform (it docks with roughly
     translate(100%,-50%)), so its left/top properties do NOT correspond to
     where it appears - v1.1 set left/top from measured screen coordinates
     and sent the tab off the top of the viewport. Position is therefore
     applied by MEASURING the union with left/top pinned to 0 and then
     offsetting from that baseline, which is immune to any transform or
     containing-block surprise.
   - The widget keeps resizing for a moment after it appears, so the stored
     spot is re-asserted on a few settle passes and on a ResizeObserver.
   The widget is found by walking up from its own toggle button
   (._hj-widget-container button[id^="hj-survey-toggle"]) to the nearest
   fixed-position ancestor, so nothing depends on Hotjar's hashed emotion
   class names, and it re-attaches if Hotjar re-renders the widget.
   Additive asset - remove its loader line in
   snippets/filtrous-cart-drawer.liquid to revert; the stored position key
   just goes unread and Hotjar returns to its default corner. */
(function () {
  'use strict';
  if (window.__fhjTab) return;
  window.__fhjTab = true;

  var KEY = 'fv3-hj-pos';
  var LOW_Z = '2147482000';
  var TOGGLE = '._hj-widget-container button[id^="hj-survey-toggle"]';

  var panel = null;
  var target = null;   // {l,t} - where the VISIBLE box should sit
  var dragging = false, moved = false, sx = 0, sy = 0, ox = 0, oy = 0;

  function findPanel() {
    if (panel && panel.isConnected) return panel;
    panel = null;
    var btn = document.querySelector(TOGGLE);
    if (!btn) return null;
    var n = btn.parentElement;
    while (n && n !== document.body && getComputedStyle(n).position !== 'fixed') n = n.parentElement;
    if (!n || n === document.body) return null;
    panel = n;
    initPanel(panel);
    return panel;
  }

  /* the rotated tab hangs outside the widget box, so everything is measured
     against the union of the widget and its own controls */
  function unionRect(el) {
    var r = el.getBoundingClientRect();
    var l = r.left, t = r.top, rt = r.right, b = r.bottom;
    [].slice.call(el.querySelectorAll('button')).forEach(function (c) {
      var cr = c.getBoundingClientRect();
      if (!cr.width || !cr.height) return;
      if (cr.left < l) l = cr.left;
      if (cr.top < t) t = cr.top;
      if (cr.right > rt) rt = cr.right;
      if (cr.bottom > b) b = cr.bottom;
    });
    return { left: l, top: t, w: rt - l, h: b - t };
  }

  /* x,y = desired top-left of the visible box, clamped into the viewport.
     Measured from a left/top:0 baseline so the widget's own transform can't
     throw the result off. target records what was achieved, so re-applying
     is idempotent. */
  function applyUnion(x, y) {
    if (!panel) return;
    var s = panel.style;
    s.setProperty('right', 'auto', 'important');
    s.setProperty('bottom', 'auto', 'important');
    s.setProperty('left', '0px', 'important');
    s.setProperty('top', '0px', 'important');
    var base = unionRect(panel);   // where the union lands with left/top = 0
    var maxX = Math.max(4, window.innerWidth - base.w - 4);
    var maxY = Math.max(4, window.innerHeight - base.h - 4);
    var ux = Math.min(Math.max(x, 4), maxX);
    var uy = Math.min(Math.max(y, 4), maxY);
    s.setProperty('left', (ux - base.left) + 'px', 'important');
    s.setProperty('top', (uy - base.top) + 'px', 'important');
    target = { l: ux, t: uy };
  }
  function reapply() {
    if (!target || !panel || !panel.isConnected || dragging) return;
    var u = unionRect(panel);
    if (Math.abs(u.left - target.l) < 1 && Math.abs(u.top - target.t) < 1) return;
    var want = { l: target.l, t: target.t };
    applyUnion(want.l, want.t);
  }
  function settle() {
    [60, 200, 500, 1000, 1800].forEach(function (ms) { setTimeout(reapply, ms); });
  }

  function savePos() {
    if (!target) return;
    try { localStorage.setItem(KEY, JSON.stringify({ l: Math.round(target.l), t: Math.round(target.t) })); } catch (e) {}
  }
  function restorePos() {
    var s = null;
    try { s = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (!s || typeof s.l !== 'number' || typeof s.t !== 'number') return;
    applyUnion(s.l, s.t);
    target = { l: s.l, t: s.t };   // keep the INTENT, not an early clamp
    settle();
  }

  function onMove(e) {
    if (!dragging || !panel) return;
    var dx = e.clientX - sx, dy = e.clientY - sy;
    if (!moved && (Math.abs(dx) + Math.abs(dy)) < 6) return;
    moved = true;
    e.preventDefault();
    applyUnion(ox + dx, oy + dy);
  }
  function onUp() {
    document.removeEventListener('pointermove', onMove, true);
    document.removeEventListener('pointerup', onUp, true);
    document.removeEventListener('pointercancel', onUp, true);
    dragging = false;
    if (panel) panel.style.removeProperty('transition');
    if (!moved) return;
    savePos();
    settle();   // the widget may re-dock its tab after the move
    /* swallow the click that ends the drag so the survey doesn't open;
       self-clears quickly so a later genuine click is never eaten */
    var clear = function () { document.removeEventListener('click', sup, true); };
    var sup = function (ev) { ev.preventDefault(); ev.stopPropagation(); clear(); };
    document.addEventListener('click', sup, true);
    setTimeout(clear, 250);
  }
  function onDown(e) {
    if (e.button && e.button !== 0) return;
    if (!findPanel()) return;
    var u = unionRect(panel);
    sx = e.clientX; sy = e.clientY; ox = u.left; oy = u.top;
    moved = false; dragging = true;
    panel.style.setProperty('transition', 'none', 'important');
    document.addEventListener('pointermove', onMove, true);
    document.addEventListener('pointerup', onUp, true);
    document.addEventListener('pointercancel', onUp, true);
  }

  function initPanel(p) {
    if (p.getAttribute('data-fhj')) return;
    p.setAttribute('data-fhj', '1');
    if (!p.title) p.title = 'Drag to move';
    p.addEventListener('pointerdown', onDown, true);
    try { new ResizeObserver(reapply).observe(p); } catch (e) {}
    restorePos();
    updateStack();
  }

  function overlayOpen() {
    var d = document.getElementById('fcart-veil');
    var q = document.getElementById('fqv-veil');
    return !!(d && d.classList.contains('on')) || !!(q && q.classList.contains('on'));
  }
  function updateStack() {
    if (!findPanel()) return;
    if (overlayOpen()) panel.style.setProperty('z-index', LOW_Z, 'important');
    else panel.style.removeProperty('z-index');
  }

  /* watch the two overlays for open/close; they are created lazily */
  var watched = {};
  function watchVeils() {
    ['fcart-veil', 'fqv-veil'].forEach(function (id) {
      if (watched[id]) return;
      var el = document.getElementById(id);
      if (!el) return;
      watched[id] = 1;
      try { new MutationObserver(updateStack).observe(el, { attributes: true, attributeFilter: ['class', 'style'] }); } catch (e) {}
    });
  }

  function tick() {
    findPanel();
    watchVeils();
    updateStack();
  }
  function boot() {
    tick();
    try { new MutationObserver(tick).observe(document.body, { childList: true }); } catch (e) {}
    window.addEventListener('resize', reapply);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
